import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { ConsolidationSummaryType } from '@/features/dashboard/types';

async function getHistoricoPedagogicoPorAluno(params): Promise<ConsolidationSummaryType> {
  const api = await getApi();
  const { data } = await api.get<ConsolidationSummaryType>('/termometro/pedagogico/historico/', {params});
  return data;
}

type QueryFnType = typeof getHistoricoPedagogicoPorAluno;

function useHistoricoPedagogicoPorAluno(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-historico-pedagogico-por-aluno', params],
    queryFn: () => getHistoricoPedagogicoPorAluno(params),
  });
}

export { getHistoricoPedagogicoPorAluno, useHistoricoPedagogicoPorAluno };
